<template>
  <!-- 타입은 고객사례, 뉴스 두가지 -->
  <section>
    <h3
      v-if="props.type !== 'result'"
      :class="{ type_underline: props.type !== 'news' }"
    >
      {{ props.title }}<span class="screen_out">검색하기</span>
    </h3>
    <h3
      v-else
      class="type_result type_underline"
    >
      ‘{{ totalSearchKeyword.searchWord }}’ <br />검색 결과
      <em class="num_result">{{ props.lengthResult }}</em
      >건
    </h3>
    <div class="area_search">
      <!-- 셀렉트 -->
      <SelectCate
        v-if="props.type === 'news'"
        :optList="listNewsCate"
        @selectItem="selectItem"
      />
      <!-- sort 선택영역 -->
      <ul
        v-if="isSortOpen"
        ref="wrapSort"
        class="wrap_sort"
      >
        <li
          v-for="(item, idx) in sortData"
          :key="`item_sort_${idx}`"
          :class="{ isSelected: item.isSelected }"
        >
          <button
            type="button"
            class="btn_sort"
            :data="item.data"
            @click="selectSort(idx)"
          >
            {{ item.name }}
          </button>
        </li>
      </ul>
    </div>
  </section>
</template>
<script setup>
import { useTotalSearchKeyword } from '/stores/store';
import { useBusinessServices } from '/composables/business';

const totalSearchKeyword = useTotalSearchKeyword();

const isSortOpen = ref(true);
const emit = defineEmits(['doSearch']);
const props = defineProps({
  title: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: '',
  },
  searchData: {
    type: Object,
    default() {
      return {};
    },
  },
  keywordResult: {
    type: String,
    default: '',
  },
  lengthResult: {
    type: Number,
    default: 0,
  },
});
const compSearchData = ref({
  //검색시 보낼 영역
  dataNewsCate: {},
  dataSort: {},
});
onMounted(() => {
  //처음값 세팅
  compSearchData.value = props.searchData;
});
const listNewsCate = ref([
  {
    name: '전체',
    isSelected: true,
    data: '',
    isSortView: true,
  },
  {
    name: '언론보도',
    isSelected: false,
    data: 'REPORT',
    isSortView: true,
  },
  {
    name: '인사이트',
    isSelected: false,
    data: 'INSIGHT',
    isSortView: false,
  },
  {
    name: '알립니다',
    isSelected: false,
    data: 'NOTICE',
    isSortView: false,
  },
]);

const { business: listBusiness } = await useBusinessServices();

const listCategory = ref([
  {
    name: '전체',
    isSelected: true,
    data: '',
  },
  {
    name: '서비스',
    isSelected: false,
    data: 'service',
  },
  {
    name: '고객사례',
    isSelected: false,
    data: 'partner',
  },
  {
    name: '뉴스',
    isSelected: false,
    data: 'news',
  },
  {
    name: '자료실',
    isSelected: false,
    data: 'information',
  },
]);

const doSearch = () => {
  emit('doSearch');
};

const sortData = computed(() => {
  switch (props.type) {
    case 'result':
      return listCategory.value; //검색
    case 'download':
      return listBusiness.value; //자료실
    default:
      return setExcludedList(listBusiness.value, '디케이테크인'); //고객사례, 뉴스에서 디케이테크인 카테고리 미노출 처리
  }
});

const setSortData = (index) => {
  //비즈니스 카테고리 선택된값으로 세팅
  sortData.value.forEach((ele, idx) => {
    ele.isSelected = index === idx;
  });
  compSearchData.value.dataSort = sortData.value[index];
};

//비즈니스 카테고리 선택 동작
const selectSort = (index) => {
  setSortData(index);
  doSearch();
};

// 셀렉트 동작
const selectItem = (index) => {
  listNewsCate.value.forEach((ele, idx) => {
    if (index !== idx) {
      ele.isSelected = false;
    } else {
      ele.isSelected = true;
      compSearchData.value.dataNewsCate = ele;
      isSortOpen.value = ele.isSortView;
      if (!isSortOpen.value) {
        //비즈니스 카테고리 숨기는 경우 전체 값으로 솔트 변경
        setSortData(0);
      }
      doSearch();
    }
  });
};
</script>
<style lang="scss" scoped>
section {
  width: 280px;
  height: 600px;
}
h3 {
  margin-top: 5px;
  font-size: 34px;
  letter-spacing: -0.5px;
  &.type_underline {
    padding-bottom: 48px;
    border-bottom: 1px solid #f0f0f0;
  }
  &.type_result {
    font-size: 28px;
    word-break: break-all;
  }
}
.num_result {
  font-weight: 700;
  color: #1b72ff;
}
.area_search {
  margin-top: 32px;
}
.wrap_sort {
  margin-top: 48px;
  li {
    & + li {
      margin-top: 8px;
    }
    button {
      width: 100%;
      color: #999;
      font-size: 18px;
      line-height: 1.67;
      text-align: left;
    }
    &.isSelected {
      button {
        color: #1a1a1a;
        font-weight: 500;
      }
    }
  }
}
</style>
